import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const HeartFilled = createSvgIcon(
  <path d="M11.165 2.49C9.68 1.12 8.702.75 7 .75c-3.3 0-7 2.625-7 7.125 0 3.068.75 4.023 5.25 8.625 1.698 1.806 3.707 3.768 5.147 5.172l.085.082c.666.65 1.202 1.173 1.518 1.496.318-.325.858-.852 1.53-1.508l.073-.071c1.44-1.405 3.447-3.367 5.147-5.171 4.5-4.602 5.25-5.557 5.25-8.625 0-4.5-3.7-7.125-7-7.125-1.702 0-2.68.37-4.165 1.74-.26.24-.537.512-.835.817a22.727 22.727 0 0 0-.835-.816Z" />,
  'HeartFilled'
);

export { HeartFilled };